/**
 * @fileoverview AR-805 — push a 1–5 grade to the linked Classroom assignment
 * as a draft. Mirrors the prototype's handleClassroomGradeChange (optimistic
 * update stays in the drawer section; this hook only wraps the GradePort).
 * Failures reject with ClassroomPortError so the UI maps `code` to PRD §6 copy.
 */

import { useCallback, useState } from 'react'

import { getClassroomAdapters } from '../provider'
import { GradePushResult } from '../types'

export interface ClassroomGradeState {
  pushing: boolean
  pushGrade: (activityId: string, studentId: string, grade: number | null) => Promise<GradePushResult>
}

export function useClassroomGrade(): ClassroomGradeState {
  const { grade: gradePort } = getClassroomAdapters()
  const [pushing, setPushing] = useState(false)

  const pushGrade = useCallback(
    async (activityId: string, studentId: string, grade: number | null) => {
      setPushing(true)
      try {
        return await gradePort.pushGrade(activityId, studentId, grade)
      } finally {
        setPushing(false)
      }
    },
    [gradePort],
  )

  return { pushing, pushGrade }
}
